const YTPlayer = require('yt-player');

export default {
  init() {

  },
  finalize() {

    const $bannerSplash = $('.banner-splash-wrap');
    const $bannerVideo = $('#banner-video');

    if ($bannerVideo.length > 0) {
      const videoId = $bannerVideo.data('video-id');

      const player = new YTPlayer('#banner-video');
      player.load(videoId);

      $bannerSplash.on('click', function() {
        $bannerSplash.addClass('d-none');
        player.play();
      });

      player.on('ended', () => {
        $bannerSplash.removeClass('d-none');
      });
    }

  },
}


// WEBPACK FOOTER //
// ./scripts/routes/templateLanding.js